import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/** Settings → Saveenergee (settings/Saveenergee::*): profilele de ore de lucru si setarile de consum. */
export type SaveenergeeSettingsTab = { id: string; label: string; icon: string; href: string; right: string }
export type SaveenergeeSettingsShell = { pageTitle: string; moduleUrl: string; tabs: SaveenergeeSettingsTab[] }

export const TABS = ['profiles', 'consuming'] as const
export type SaveenergeeSettingsTabId = (typeof TABS)[number]

export function isSaveenergeeSettingsTab(value: string): value is SaveenergeeSettingsTabId {
  return (TABS as readonly string[]).includes(value)
}

export type ProfilesPage = { company: number; profiles: { ID: number; profile_name: string }[]; days_of_week: Record<string, string> }
export type BusinessDay = { day: number; dayString: string; checked: boolean; start: string; end: string }
export type ProfileSheet = { profile_id: number; company: number; profile_name: string; hibernate_after: number; monitor_sleep_after: number; businessHours: BusinessDay[] }
export type ConsumingPage = {
  company: number
  company_settings: { desktop_consuming: number; laptop_consuming: number; server_consuming: number; desktop_display_consuming: number; laptop_display_consuming: number; consuming_price: number; currency: string }
  currencies: Record<string, string>
}
export type WriteAnswer = { ok?: boolean; id?: number; message?: string }

export function saveenergeeSettingsShellQuery() {
  return queryOptions({ queryKey: ['settings', 'saveenergee', 'shell'], queryFn: () => apiGet<SaveenergeeSettingsShell>('/settings/saveenergee') })
}

export function profilesQuery() {
  return queryOptions({ queryKey: ['settings', 'saveenergee', 'profiles'], queryFn: () => apiGet<ProfilesPage>('/settings/saveenergee/profiles') })
}

export function profileQuery(id: number) {
  return queryOptions({ queryKey: ['settings', 'saveenergee', 'profiles', id], queryFn: () => apiGet<ProfileSheet>('/settings/saveenergee/profiles/' + id) })
}

export function consumingQuery() {
  return queryOptions({ queryKey: ['settings', 'saveenergee', 'consuming'], queryFn: () => apiGet<ConsumingPage>('/settings/saveenergee/consuming') })
}

export function post(path: string, fields: Record<string, PostValue> = {}) {
  return apiPost<WriteAnswer>('/settings/saveenergee' + path, fields)
}
